import React, { useState } from "react";

import BaseCard from "../../../../../components/ui/BaseCard";
import AddSkillsModal from "../../../components/AddSkillsModal";
import { useQuery } from "@tanstack/react-query";
import { fetchUserSkills } from "../../../../../services/api/user";

const AddSkills = ({ userId }) => {
  const [isAddSkillsModalOpen, setIsAddSkillsModalOpen] = useState(false);

  const {
    isPending: isUserSkillsLoading,
    error: isUserSkillsError,
    refetch: refetchUserSkills,
    data: userSkillsData,
  } = useQuery({
    queryKey: ["userSkillsData"],
    queryFn: () => fetchUserSkills(userId),
    retry: 2,
    enabled: !!userId,
  });

  return (
    <form>
      <BaseCard
        className="py-3 px-4 mt-3 border rounded-lg shadow-sm"
        elevation={0}
      >
        <div className="bg-light rounded-sm py-2 px-4 mb-4 flex items-center justify-between">
          <p className="text-base font-normal">Add Skills</p>
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-secondary text-xl"
            onClick={() => setIsAddSkillsModalOpen(true)}
          ></i>
        </div>

        <div className="flex flex-wrap gap-4">
          {userSkillsData?.data?.map((skill) => (
            <div className="flex items-center px-4 py-1 bg-light rounded-sm">
              <p key={skill.id}>
                {skill.category}/{skill.vendor}/{skill?.subCategory}
              </p>
              <i
                className="fa-solid fa-xmark ml-2 cursor-pointer hover:text-blue-500"
                // onClick={() => handleDeleteUserSkill(skill.id)}
              ></i>
            </div>
          ))}
        </div>
      </BaseCard>
      <AddSkillsModal
        close={setIsAddSkillsModalOpen}
        open={isAddSkillsModalOpen}
        refetchUserSkills={refetchUserSkills}
        userId={userId}
      />
    </form>
  );
};

export default AddSkills;
